import { API_URL, MOKA_SERVICE_HOST } from 'api/constants';

export const ITEMS_EXPORT = `${API_URL}/v1/items/import_items_template`;
export const ITEMS_EXPORT_V3 = `${API_URL}/v3/items/import_items_template`;
export const ITEM_DOWNLOAD_TEMPLATE = `ITEM_DOWNLOAD_TEMPLATE`;
export const LIST_ITEM_URL = `${API_URL}/v1/items`;
export const ITEM_SUMMARY_URL = `${API_URL}/v1/items/summary`;
export const ITEMS_TEMPLATE = `${API_URL}/v1/items/import_items_template`;
export const ITEM_BY_ID = id => `${LIST_ITEM_URL}/${id}`;
export const ITEM_BY_ID_V3 = id => `${LIST_ITEM_URL_V3}/${id}`;
export const CREATE_ITEM = `${API_URL}/v3/items`;
export const CREATE_ALL_OUTLET_ITEM = `${API_URL}/v1/items/create_all_outlet`;
export const UPDATE_ITEM_BY_ID = id => `${ITEM_BY_ID(id)}/update_image`;
export const DELETE_ITEM_BY_ID_V1 = id => `${ITEM_BY_ID(id)}`;
export const DELETE_ITEM_BY_ID_V3 = id => `${ITEM_BY_ID_V3(id)}`;
export const GET_NEW_ITEM_V1 = `${LIST_ITEM_URL}/new`;

/**
 * API V3
 */
export const LIST_ITEM_URL_V3 = `${API_URL}/v3/items`;
export const GET_MODIFIERS_LIST = `${MOKA_SERVICE_HOST}/inventory/v1/modifiers/get_modifiers_list`;

/**
 * Inventory API
 */
export const LIST_ITEM_URL_INVENTORY_V1 = `${MOKA_SERVICE_HOST}/inventory/v1/items`;
export const ITEM_BY_ID_INVENTORY_V1 = id =>
  `${MOKA_SERVICE_HOST}/inventory/v1/items/${id}`;
export const UPDATE_ALL_OUTLET_BY_ID_V1 = id =>
  `${MOKA_SERVICE_HOST}/inventory/v1/items/${id}/update_all_outlet`;
export const BRAND_BASE_URL = outletId =>
  `${MOKA_SERVICE_HOST}/inventory/v1/brands/outlets/${outletId}`;
export const GET_ITEM_BY_ID_V2 = id =>
  `${MOKA_SERVICE_HOST}/inventory/v2/items/${id}`;
export const DELETE_ITEM_BY_ID_INVENTORY_V1 = id =>
  `${ITEM_BY_ID_INVENTORY_V1(id)}`;
export const NEW_ITEM_URL_INVENTORY_V1 = `${MOKA_SERVICE_HOST}/inventory/v1/items/new`;
export const UPDATE_ITEM_BY_ID_INVENTORY_V1 = id =>
  `${MOKA_SERVICE_HOST}/inventory/v1/items/${id}/update_image`;
export const VALIDATE_SAVE_TO_ALL_OUTLET = `${LIST_ITEM_URL_INVENTORY_V1}/validate_create_all_outlet`;
export const CREATE_ALL_OUTLET_ITEM_INVENTORY = `${LIST_ITEM_URL_INVENTORY_V1}/create_all_outlet`;
export const ITEM_EXPORT_INVENTORY_V1 = `${MOKA_SERVICE_HOST}/inventory/v1/items/export`;
export const POST_ITEM_IMAGE_ECOMMERCE = outletId =>
  `${MOKA_SERVICE_HOST}/inventory/v1/items/outlets/${outletId}/ecommerce-image`;
export const GET_ECOMMERCE_CATEGORY = `${MOKA_SERVICE_HOST}/inventory/v1/business/ecommerce-category/detail`;
